import { useContext, useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { checkPermission, EMPTY_MENU_LABELS, EMPTY_ROUTE_NAMES, MenuItem, menuItems } from "./Sidebar";
import { MENU_NAMES } from "../../constant";
import { useLocation, useNavigate } from "react-router-dom";
import { TutorialContext } from "../../contexts/TutorialContext";
import { userRoles } from "../../constant";
import { ReactComponent as Logout } from "../../assets/icons/logout.svg";
import { useApp } from "../../services/app-context";

const framerSidebarBackground = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0, transition: { delay: 0.1 } },
  transition: { duration: 0.3 },
};

const framerSidebarPanel = {
  initial: { x: "-100%" },
  animate: { x: 0 },
  exit: { x: "-100%" },
  transition: { duration: 0.3 },
};
export function MobileHeaderMenu({
  onClose,
  className = "",
  overlayClassName = "",
  onEdit,
  onLogout,
  user = {},
  userInfoLoading = false,
}: {
  onClose: () => void;
  className?: string;
  overlayClassName?: string;
  onEdit: () => void;
  onLogout: () => void;
  user: any;
  userInfoLoading: boolean;
}) {
  const location = useLocation();
  const { tenantProfile } = useApp();
  const menuLabels = tenantProfile?.menuLabels ?? EMPTY_MENU_LABELS;
  const routeNames = tenantProfile?.routeNames ?? EMPTY_ROUTE_NAMES;
  const isSelected = (path) => {
    if (location.pathname.includes(path)) {
      return true;
    }
    return false;
  };
  const [openDropdown, setOpenDropdown] = useState(false);

  const handleClose = () => {
    onClose();
  };

  const disableScroll = () => {
    document.body.style.overflow = "hidden";
  };

  const enableScroll = () => {
    document.body.style.overflow = "";
  };

  useEffect(() => {
    disableScroll();
    return () => enableScroll();
  }, []);

  const navigate = useNavigate();
  const tutorialContext = useContext(TutorialContext);

  const handleClick = (name: string | undefined) => {
    if (name === MENU_NAMES.myProfile) {
      onEdit();
      onClose();
    }
    if (name === MENU_NAMES.tutorials) {
      tutorialContext?.resetTutorial();
      navigate("/dashboard");
      onClose();
    }
  }

  const menus = useMemo(() => {
    if (userInfoLoading) {
      return menuItems(menuLabels, routeNames);
    }
    if (user?.role === userRoles.Manager) {
      return [
        ...menuItems(menuLabels, routeNames),
        // {
        //   title: "Users",
        //   Icon: UsersIcon,
        //   path: "/users",
        // },
      ];
    }
    return menuItems(menuLabels, routeNames);
  }, [user, userInfoLoading, menuLabels, routeNames]);

  return (
    <>
      <motion.div
        {...framerSidebarBackground}
        className={`fixed z-[5] top-[69px] h-[100vh] left-0 right-0 bottom-0 bg-black/40 ${overlayClassName}`}
        onClick={handleClose}
      />
      <motion.div
        {...framerSidebarPanel}
        style={{ background: "linear-gradient(180deg, var(--menuPrimaryBg) 0%, var(--menuSecondaryBg) 100%)" }}
        className={`fixed z-[6] top-[69px] h-[calc(100%-69px)] left-0 right-0 flex flex-col justify-between bg-menuPrimaryBg w-[70%] md:w-[40%] ${className}`}
      >
        <div className="px-2 mt-5">
        {menus
                  .filter((item) => checkPermission(item, tenantProfile, user))
                  .map((item, index) => (
                    <MenuItem item={item} collapsed={false} isSelected={isSelected} index={index} key={index} tenantProfile={tenantProfile} user={user} onClick={handleClick} menuLabels={menuLabels} />
                  ))}
        </div>
        <div className="relative">
          {/* <UserButton
            user={userInfo}
            variant="sideMenu"
            onClick={() => setOpenDropdown(true)}
          /> */}

          {/* <Dropdown
            padding="15px"
            className="w-[calc(100%-32px)] !top-[-100px] left-4"
            isOpen={openDropdown}
            setIsOpen={() => setOpenDropdown(false)}
          >
            <button
              className="!pb-[2px] text-[#212424] text-base"
              onClick={() => {
                onClose();
                onEdit();
              }}
            >
              Edit Profile
            </button>
            <button
              className="text-[#E3270E] text-base pt-3"
              onClick={() => {
                onClose();
                onLogout();
              }}
            >
              Logout
            </button>
          </Dropdown> */}
          <div className="mb-4 flex justify-center items-center">
            <button
              onClick={() => {
                onClose();
                onLogout();
              }}
              className={`text-center items-center gap-1 flex group-hover:opacity-80 text-text-link text-base font-normal`}
            >
              <Logout
                className={`w-5 h-5 relative group-hover:opacity-80 [&_path]:stroke-text-link`}
              />
              Logout
            </button>
          </div>
        </div>
      </motion.div>
    </>
  );
}
